import { render, staticRenderFns } from "./UserEPwd.vue?vue&type=template&id=5d2fb872"
import script from "./UserEPwd.vue?vue&type=script&lang=js"
export * from "./UserEPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports